
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prizes/details/[slug]",
      function () {
        return require("private-next-pages/prizes/details/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prizes/details/[slug]"])
      });
    }
  